import {
  electronicFormatIBAN,
  isValidIBAN as hasValidIbanFormat,
} from "ibantools";

/** Accepts the spaced, mixed-case form an investor copies off a bank statement. */
export const isValidIBAN = (iban?: string | null): boolean =>
  hasValidIbanFormat(electronicFormatIBAN(iban ?? undefined) ?? "");
